import PropTypes from 'prop-types'

const InlineBadge = ({ text, color = 'gray' }) => {
  const getColorStyles = (color) => {
    const styles = {
      green: 'bg-green-900/30 text-green-400 border-green-700/50',
      red: 'bg-red-900/30 text-red-400 border-red-700/50',
      blue: 'bg-blue-900/30 text-blue-400 border-blue-700/50',
      yellow: 'bg-yellow-900/30 text-yellow-400 border-yellow-700/50',
      gray: 'bg-gray-900/30 text-gray-400 border-gray-700/50',
      purple: 'bg-purple-900/30 text-purple-400 border-purple-700/50',
      cyan: 'bg-cyan-900/30 text-cyan-400 border-cyan-700/50',
    }
    return styles[color] || styles.gray
  }

  return (
    <span
      className={`
        inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full
        border ${getColorStyles(color)}
      `}
    >
      {text}
    </span>
  )
}

InlineBadge.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.oneOf(['green', 'red', 'blue', 'yellow', 'gray', 'purple', 'cyan']),
}

export default InlineBadge
